import { useRef } from 'react';
import { useSelector } from 'react-redux';
import { getFocusedFieldKeys } from '../selectors/appSelectors';
import { getThemeSelectorsMap } from '../selectors/themeSelectors';
const ThemePreviewHighlightingContainer = ({
  isUniversalThemeEditing
}) => {
  const focusedFieldKeys = useSelector(getFocusedFieldKeys);
  const themeSelectorsMap = useSelector(getThemeSelectorsMap);
  const styleElement = useRef(null);
  const selectors = focusedFieldKeys.reduce((acc, fieldKey) => {
    let fieldSelectors = themeSelectorsMap[fieldKey];

    // If field has no selectors, check parent field group and parent field group's
    // parent for selectors to trickle down
    if (!fieldSelectors) {
      const fieldKeyList = fieldKey.split('.');
      const parentFieldGroupKey = fieldKeyList.slice(0, -1).join('.');
      const parentGroupParentKey = fieldKeyList.slice(0, -2).join('.');
      const parentFieldGroupSelectors = themeSelectorsMap[parentFieldGroupKey];
      const fieldGroupParentSelectors = themeSelectorsMap[parentGroupParentKey];
      fieldSelectors = parentFieldGroupSelectors || fieldGroupParentSelectors;
    }
    if (fieldSelectors) {
      acc.push(...fieldSelectors);
    }
    return acc;
  }, []);

  // eslint-disable-next-line react-hooks/refs
  if (!styleElement.current) {
    styleElement.current = document.createElement('style');
    // eslint-disable-next-line react-hooks/refs
    styleElement.current.className = '_HS-theme-settings-preview-styles';
    // eslint-disable-next-line react-hooks/refs
    document.getElementsByTagName('body')[0].appendChild(styleElement.current);
  }

  // TODO: right now the correct theme cannot be accessed from within this iframe
  // so we're using a hardcoded color for now. See this slack thread for more details:
  // https://hubspot.slack.com/archives/C1WG3L3J6/p1749766019165059
  const outlineOffsetStyle = isUniversalThemeEditing ? '-1px; outline: 1px solid #00a4bd;' : '-3px; outline: 3px solid #016DE1;';

  // eslint-disable-next-line react-hooks/refs
  styleElement.current.innerText = selectors.reduce((styles, fieldName) => {
    return `${styles} ${fieldName} { outline-offset: ${outlineOffsetStyle} }`;
  }, '');
  return null;
};
export default ThemePreviewHighlightingContainer;